import { render } from "./system-banner.vue?vue&type=template&id=3841a558&scoped=true"
import script from "./system-banner.vue?vue&type=script&lang=js"
export * from "./system-banner.vue?vue&type=script&lang=js"

import "./system-banner.vue?vue&type=style&index=0&id=3841a558&lang=css"
import "./system-banner.vue?vue&type=style&index=1&id=3841a558&scoped=true&lang=css"

import exportComponent from "/home/aaicom7/repositories/prod/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3841a558"]])

export default __exports__